import { ReactNode } from "react";
import { SubNav, SubNavTab } from "@/components/layout/SubNav";

interface SecurityLayoutProps {
  children: ReactNode;
  onRefresh?: () => void;
  isRefreshing?: boolean;
}

const securityTabs: SubNavTab[] = [
  { label: "Users", path: "/security/users" },
  { label: "Roles", path: "/security/roles" },
];

export const SecurityLayout = ({ children, onRefresh, isRefreshing }: SecurityLayoutProps) => {
  return (
    <div className="flex flex-col h-full">
      <SubNav tabs={securityTabs} onRefresh={onRefresh} isRefreshing={isRefreshing} />
      <main className="flex-1 overflow-y-auto bg-[#F5F5F5]">
        {children}
      </main>
    </div>
  );
};

